import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadPageData } from "../../actions";
import SCCustomerPlansTable from "./css";
import {
  SCCustomerPlans,
  SCHeaderButton,
  SCCustomerNoPlans,
  SCPlanSearch
} from "./css";
import {
  PLAN_TABLE_HEADER,
  PLAN_NOT_FOUND,
} from "../../util/constants/types";
import Loader from "../Common/Loader";
import { FilterResult } from "./FilterResult";
import { SearchResult } from "./SearchResult";
import history from "../../history";

import {
  Search
} from "@payright/web-components";
import Footer from "../Footer";
import { NavWithComponent } from "../Nav";
import { RootState } from "../../reducers";
import TableWithPagination from "../TableWithPagination/TableWithPagination";

const lowercaseKeys = require("lowercase-keys");

const options = {
  Active: false,
  Approved: false,
  Incomplete: false,
  Declined: false,
  Closed: false,
  Cancelled: false,
  Review: false
};

type PlanSelector = {
  customer: any;
  plans?: any[];
  loading: boolean;
  error: {
    message: string;
  };
}

export const Plan: React.FC<{}> = () => {
  const dispatch = useDispatch();

  const [searchItem, setSearchItem] = React.useState("");
  const [searchFilterOptions, setSearchFilterOptions] = React.useState([]);
  const { customer, error, loading, plans } = useSelector<RootState, PlanSelector>(state => ({
    customer: state.pageData.customer,
    error: state.pageData.error,
    loading: state.pageData.loading,
    plans: state.pageData.plans ?? [],
  }));

  React.useEffect(() => {
    if (!customer) {
      dispatch(loadPageData());
    }
  }, [dispatch, customer, dispatch]);

  const handleChangeValue = value => {
    setSearchItem(value);
  };

  const handleUpdateFilter = filterValues => {
    const filterObject = lowercaseKeys(filterValues.options);
    Object.keys(filterObject).forEach(obj => {
      if (filterObject[obj] !== true) {
        delete filterObject[obj];
      }
    });
    const validKeys = Object.keys(filterObject).map(planFilterStatus => {
      if (planFilterStatus === "incomplete") {
        return "pending";
      }
      return planFilterStatus;
    });
    setSearchFilterOptions(validKeys);
  };

  const handleMakeAPayment = () => {
    history.push("/payments");
  }


  if (error) {
    return <div>Error! {error.message}</div>;
  }

  if (loading) {
    return <Loader text="Loading..." />;
  }

  let currentPlans = plans;

  if (searchItem !== "") {
    currentPlans = SearchResult(currentPlans, searchItem);
  } else if (searchFilterOptions.length > 0) {
    currentPlans = FilterResult(currentPlans, searchFilterOptions);
  }

  return (
    <>
      <NavWithComponent title="My Plans" activePage="/my-plans" component={
            <SCHeaderButton
              maxWidth="209px"
              handleClick={handleMakeAPayment}
            >
              Make a Payment
            </SCHeaderButton>} />

      <SCPlanSearch>
        <Search
          placeholder="Search"
          inputChangeHandler={handleChangeValue}
          filterCheckboxes={options}
          updateFiltersHandler={handleUpdateFilter}
        />
      </SCPlanSearch>

      {currentPlans.length > 0 ? (
        <SCCustomerPlans>
          <div>
            <TableWithPagination
              tableHeaders={PLAN_TABLE_HEADER}
              rawData={currentPlans}
              initialSortField="planName.name"
              Table={SCCustomerPlansTable}
            />
          </div>
        </SCCustomerPlans>
      ) : (
        <SCCustomerNoPlans>{PLAN_NOT_FOUND}</SCCustomerNoPlans>
      )}
      <Footer />
    </>
  );
};

export default Plan;
